<template>
    <v-menu ref="menu" v-model="isDatePickerVisible" :close-on-content-click="false" transition="scale-transition"
        offset-y min-width="290px" :disabled="disabled" :open-on-click="false" >
        <template v-slot:activator="{ on }">
            <v-text-field v-model="dtBase" :rules="rules" :label="label" v-on="on" outlined @click:append="showPicker"
                append-icon="mdi-calendar" return-masked-value v-mask="mask" :clearable="!disabled && clearable"
                          :error-messages="errorMessages"
                :disabled="disabled">
            </v-text-field>
        </template>
        <v-date-picker :full-width="isMobile" color="info" v-model="dataSelecionada" :landscape="!isMobile"
            scrollable locale="pt-br" @input="isDatePickerVisible = false" :max="maxDateAllowed" :min="minDateAllowed">
        </v-date-picker>
    </v-menu>
</template>

<script>
    import { dateIsoToLocal, dateLocalToIso } from '@/filters/utils'
    import { mask } from 'vue-the-mask'

    export default {
        props: {
            label: String,
            dateValue: String,
            formatoInvertido: Boolean,
            rules: Array,
            value: String,
            disabled: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: true
            },
            maxDateAllowed: {
                type: String,
                default: ''
            },
            minDateAllowed: {
                type: String,
                default: ''
            },
            errorMessages: {
                type: Array,
                default: () => []
            }
        },
        model:{
            prop: 'value',
            event: 'input',
        },
        directives: {
            mask,
        },
        data () {
            return {
                isDatePickerVisible: false,
                dataSelecionada: null,
                mask: '##/##/####'
            }
        },
        computed: {
            isMobile() {
                return this.$vuetify.breakpoint.xs
            },
            dtBase: {
                get() {
                    return this.value
                },
                set(value) {
                    if (this.formatoInvertido)
                    {
                        this.$emit('input', this.dateLocalToIso(value))
                    }
                    else
                    {
                        this.$emit('input', value)
                    }
                }
            }
        },
        methods: {
            dateIsoToLocal: dateIsoToLocal,
            dateLocalToIso: dateLocalToIso,
            showPicker() {
                this.isDatePickerVisible = true
                if(this.formatoInvertido){
                    this.dataSelecionada = this.dtBase
                } else{
                    this.dataSelecionada = this.dateLocalToIso(this.dtBase)
                }
            },
        },
        watch: {
            dataSelecionada (val) {
                this.dtBase = this.dateIsoToLocal(val)
            },
            dtBase (value) {
                if (this.formatoInvertido)
                {
                    this.$emit('input', this.dateLocalToIso(value))
                }
                else
                {
                    this.$emit('input', value)
                }
            },
            value (val) {
                if(this.formatoInvertido){
                        this.dataSelecionada = val
                } else {
                        if(val && val.length == 10)
                            this.dataSelecionada = this.dateLocalToIso(val)
                }
            }

        }
    }
</script>
